import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import Title from 'pages/Landings/components/Title';

import Question from './components/Question';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Questions: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.header}>
                <Title variant="h2" align="left">
                    Have a question?
                </Title>
                <Button
                    component={Link}
                    to="/company/contacts"
                    variant="contained"
                    disableElevation
                    disableFocusRipple
                    centerRipple
                    className={classes.button}
                >
                    Contact us
                </Button>
            </div>
            <div className={classes.grid}>
                <div className={classes.column}>
                    <Question title="What are Vulners API credits?">
                        {'Vulners billing is based on the types of API calls.'}
                        <br />
                        {
                            'The complexity of each type corresponds to a certain amount of credits — virtual currency used in the Vulners billing.'
                        }
                    </Question>
                    <Question title="Which payment methods do you offer?">
                        {'Vulners accepts wire transfers, credit cards, or PayPal.'}
                        <br />
                        {'Billing is available on a monthly, quarterly, and annual basis.'}
                    </Question>
                    <Question title="Can I try before I decide to pay?">
                        {'Sure, you can '}
                        <Link to="/login">sign in</Link>
                        {' to your account and start a free 30-day trial anytime.'}
                    </Question>
                    <Question title="Which currency can I use to make payments?">
                        {'Vulners prices are in dollars throughout the world, however,'}
                        <br />
                        {'we accept payments in both dollars and euro.'}
                    </Question>
                </div>
                <div className={classes.column}>
                    <Question title="Where can I check my API credits balance?">
                        {'You can '}
                        <Link to="/login">sign in</Link>
                        {
                            ' to your account and see the amount of credits you have used in the current month in a dashboard.'
                        }
                    </Question>
                    <Question title="Do you offer discounts?">
                        {'Yes, you can switch to annual billing to pay less, or email '}
                        <a href="mailto:sales@vulners.com">sales@vulners.com</a>
                        {' for an individual quote.'}
                    </Question>
                    <Question title="How do I switch to annual billing?">
                        {'Send request to '}
                        <a href="mailto:accounting@vulners.com">accounting@vulners.com</a>
                        {' and our team will issue a new invoice.'}
                    </Question>
                    <Question title="Can I switch or cancel my plan?">
                        {'Of course. To scale or cancel your plan, send your request'}
                        <br />
                        {'to '}
                        <a href="mailto:sales@vulners.com">sales@vulners.com</a>
                        {'.'}
                    </Question>
                </div>
            </div>
        </div>
    );
};

export default Questions;
